import * as React from "react"
import IndividualContactFormBody from "../IndividualContactFormBody";
import ContactForm from "../dto/ContactForm";
import BaseFormView, {BaseFormViewProps, BaseFormViewState} from "../../../ui/form/BaseFormView";
import IndividualContactData from "../../../../model/contact/individual/IndividualContactData";
import {none, Option, option} from "ts-option";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {RouteComponentProps, withRouter} from "react-router";
import * as validator from "validator";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface ComponentProps {
	/**
	 * Callback for individual contact form submit.
	 * @param {IndividualContactData} contact contact to add.
	 */
	createIndividualContact: (contact: IndividualContactData) => void
	/**
	 * String to use as initial data for the form.
	 */
	prePopulatedString?: Option<string>
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
}

type Props = ComponentProps & BaseFormViewProps & RouteComponentProps<ComponentProps & BaseFormViewProps>

interface ComponentState {
	/**
	 * Type of the contact.
	 */
	type: string
}

type State = ComponentState & BaseFormViewState<ContactForm>

/**
 * Add new contact form view.
 */
class AddContactFormView extends BaseFormView<ContactForm, Props, State> {

	constructor(props: Props) {
		super(props);
		const form = this.createInitialForm(props);
		this.state = {
			form: form,
			shouldValidate: false,
			type: "individual",
			isFormDirty: false
		};
		this.submitForm = this.submitForm.bind(this);
	}

	render() {
		return (
			<div>
				{this.renderFormBody()}
				<FormButtonsView align={"right"}>
					<ButtonTertiary label={"Cancel"}
									onClick={this.props.onCancel}/>
					<ButtonPrimary label={"Save contact"} onClick={this.submitForm} isLoading={this.props.isLoading}/>
				</FormButtonsView>
			</div>
		);
	}

	/**
	 * Callback onSubmit button click.
	 */
	submitForm() {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onIndividualValid(none, contactData => {
				this.props.createIndividualContact(contactData);
			}, () => {});
		});
	}

	/**
	 * Render add contact form body. Switch few depends on type of contact selected.
	 * @return {JSX.Element}
	 */
	private renderFormBody(): JSX.Element {
		return <IndividualContactFormBody form={this.state.form}
										  onFieldChange={this.onFieldChanged}
										  onFieldCompleted={() => {}}
										  onFocusChange={() => {}}
										  onFieldsChange={this.onFieldsChanged}/>;
	}

	/**
	 * Creates initial form.
	 * @param {Props} props Props of the component.
	 * @returns {ContactForm} Form for the component.
	 */
	private createInitialForm(props: Props) {
		//TODO:remove mocked siteId
		if (props.prePopulatedString && props.prePopulatedString.isDefined && !validator.isEmpty(props.prePopulatedString.get)) {
			const space = props.prePopulatedString.get.indexOf(" ");
			if (space == -1)
				return ContactForm.createContactForm({firstName: option(props.prePopulatedString.get)});
			else {
				const firstName = props.prePopulatedString.get.substr(0, space);
				const lastName = props.prePopulatedString.get.substr(space + 1, props.prePopulatedString.get.length - 1);
				return ContactForm.createContactForm(
					{firstName: option(firstName), lastName: option(lastName), primaryAddress: option("addressId")});
			}
		}
		return ContactForm.createContactForm({primaryAddress: option("addressId"), archived: option(false)});
	}
}

export default withRouter<ComponentProps & BaseFormViewProps>(AddContactFormView)